import React from 'react'
import Icon from './Icon'

class Reload extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg width='17px' height='14px' viewBox='0 0 17 14'>
          <g
            id='icons'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
          >
            <g transform='translate(-342.000000, -358.000000)' id='reload'>
              <g transform='translate(342.000000, 356.000000)'>
                <polygon id='Bounds' points='0 0 18 0 18 18 0 18' />
                <path
                  d='M9.75,2.25 C6.0225,2.25 3,5.2725 3,9 L0.75,9 L3.6675,11.9175 L3.72,12.0225 L6.75,9 L4.5,9 C4.5,6.0975 6.8475,3.75 9.75,3.75 C12.6525,3.75 15,6.0975 15,9 C15,11.9025 12.6525,14.25 9.75,14.25 C8.3025,14.25 6.99,13.6575 6.045,12.705 L4.98,13.77 C6.2025,14.9925 7.8825,15.75 9.75,15.75 C13.4775,15.75 16.5,12.7275 16.5,9 C16.5,5.2725 13.4775,2.25 9.75,2.25 L9.75,2.25 Z'
                  id='Icon'
                  className='icon__fill'
                  fill='#7E8DA2'
                  opacity='0.5'
                />
              </g>
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Reload
